<template>
	<div>
		<component
			:is="foldable ? 'AmeliproAccordion' : 'AmeliproCard'"
			v-bind="currentProps"
			:card-title="foldable ? undefined : cardTitle"
			classes="amelipro-file-preview"
		>
			<template #headerRight>
				<div
					v-if="breakpointHelper.isDesktop()"
					class="d-flex justify-end amelipro-file-preview__header-right"
				>
					<a
						class="d-flex align-center text-h6 font-weight-semibold amelipro-file-preview__header__link"
						:download="fileName"
						:href="fileSrc"
						:title="linkTitle"
					>
						{{ downloadBtnText }}

						<AmeliproIcon
							bordered
							class="ml-2"
							icon="pdf"
							icon-bg-color="ap-red"
							icon-color="ap-white"
							icon-hover-bg-color="ap-white"
							icon-hover-color="ap-red"
							large
						/>
					</a>
				</div>
			</template>

			<template #default>
				<iframe
					v-if="breakpointHelper.isDesktop()"
					class="amelipro-file-preview__iframe"
					:height="previewHeight"
					:src="fileSrc"
					:title="iframeTitle"
					type="application/pdf"
					width="100%"
				/>

				<a
					v-else
					class="d-block download-file-link"
					:download="fileName"
					:href="fileSrc"
					:title="linkTitle"
				>
					<span class="pa-4 ap-white d-flex flex-column align-center">
						<!-- TODO: Quick fix pour les TU. Trouver une meilleure solution -->
						<AmeliproIcon
							icon="pdf"
							icon-bg-color="ap-red"
							icon-color="ap-white"
							size="64px"
						/>

						<span class="download-file-link-text mt-3">
							{{ downloadBtnText }}
						</span>
					</span>
				</a>
			</template>
		</component>
	</div>
</template>

<script setup lang="ts">
	import AmeliproIcon from '../AmeliproIcon/AmeliproIcon.vue';
	import BreakpointHelper from '../../helpers/BreakpointHelper';
	import { computed } from 'vue';

	const props = defineProps({
		cardTitle: {
			type: String,
			default: undefined,
		},
		downloadBtnText: {
			type: String,
			default: 'Télécharger',
		},
		fileName: {
			type: String,
			required: true,
		},
		fileSrc: {
			type: String,
			required: true,
		},
		foldable: {
			type: Boolean,
			default: false,
		},
		iframeTitle: {
			type: String,
			default: 'Aperçu du fichier PDF',
		},
		isOpen: {
			type: Boolean,
			default: false,
		},
		linkTitle: {
			type: String,
			default: 'Télécharger le fichier au Format PDF',
		},
		previewHeight: {
			type: Number,
			default: 550,
		},
		uniqueId: {
			type: String,
			required: true,
		},
	});

	const breakpointHelper = new BreakpointHelper();

	const currentProps = computed<object>(() => (props.foldable ? { accordionTitle: props.cardTitle, isOpen: props.isOpen, uniqueId: props.uniqueId } : { cardTitle: props.cardTitle, id: props.uniqueId }));
</script>

<style lang="scss" scoped>
.download-file-link {
	&:hover {
		text-decoration: none;
	}
}

.download-file-link-text {
	color: $ap-blue-darken1;
	font-size: $font-size-sm;
	font-weight: $ap-font-weight-semi-bold;

	a:hover & {
		color: $ap-blue-darken2;
		text-decoration: underline;
	}
}
</style>
